import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_RoleAdminSU } from "../shared/data.service";
import { IntListRequest } from "../../services/IntListRequest";
import { RoleAdminSuNoRolesAddRolesComponent } from "./role-admin-su-no-roles-add-roles/role-admin-su-no-roles-add-roles.component";

@Component({
	selector: "caass-role-su-user-no-roles",
	templateUrl: "./role-su-user-no-roles.component.html",
	styleUrls: ["./role-su-user-no-roles.component.css"],
})
export class RoleSuUserNoRolesComponent implements OnInit {
	constructor(private dataService: DataService_RoleAdminSU, private confirmationService: ConfirmationService, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.loadUsers();
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////

	userpagerows: any = 10;
	userpagefirst: any = 0;

	SelectedUsers: any = [];
	lstUsers: any = [];

	lstPersonTypeDesc: any = [];
	lstUserLevelDesc: any = [];
	lstActiveDesc: any = [];

	UserCols: any = [
		{ field: "UserName", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Staff Type" },
		{ field: "SchoolFullName", header: "Home School" },
		// { field: "UserLevelDesc", header: "User Level" },
		// { field: "ActiveDesc", header: "Active" },
	];

	LoadingUser: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////

	loadUsers() {
		this.errorMessage = "";

		this.lstUsers = [];
		this.SelectedUsers = [];
		this.LoadingUser = true;

		var result = this.dataService.RoleAdminSuUserNoRolesSelect();
		result.subscribe(
			(response) => {
				this.lstUsers = response;

				//Load Data Filter Lists
				this.lstPersonTypeDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.PersonTypeDesc)));
				this.lstUserLevelDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.UserLevelDesc)));
				this.lstActiveDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.ActiveDesc)));

				this.LoadingUser = false;
			},
			(error) => {
				this.LoadingUser = false;
			}
		);
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////

	onUserRefresh() {
		this.loadUsers();
	}

	onAddRoles() {
		this.errorMessage = "";

		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select users to add roles to";
			return;
		}

		var ref = this.dialogService.open(RoleAdminSuNoRolesAddRolesComponent, {
			header: "Add Roles",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				lstSelectedUsers: this.SelectedUsers,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.SelectedUsers = []; //(If they now have roles they won't be in the list)
				this.loadUsers();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//
		// Error Handling
		//
		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select users to delete";
			return;
		}

		//
		// Confirm Delete
		//
		var Msg =
			`Are you sure you want to delete ` +
			this.SelectedUsers.length +
			` users? On normal servers these ` +
			`are the accounts someone tried to delete but the script errored. ` +
			`(NOTE: DC/SBT manages roles differently and view-only users don't have "roles" like in CAASS. ` +
			`CONFIRM with DEVELOPMENT if you are doing this on the DC Server)`;

		this.confirmationService.confirm({
			key: "NoRolesConfirm",
			acceptLabel: "Yes",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Delete Users",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Processing = true;

		var lstUIDs = this.SelectedUsers.map((item) => item.UserID);

		var parms: IntListRequest = {
			lstIDs: lstUIDs,
		};

		var result = this.dataService.UsersDeleteMultiple(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "NoRoles",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Users were deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUsers();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "NoRoles",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete users: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onExport() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"Username",`;
		DataStr += `"Staff ID",`;
		DataStr += `"First Name",`;
		DataStr += `"Last Name",`;
		DataStr += `"Staff Type",`;
		DataStr += `"Home School",`;
		DataStr += `"User Level",`;
		DataStr += `"Active",`;
		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstUsers.length; z++) {
			var next = this.lstUsers[z];

			DataStr += `"` + next.UserName + `",`;
			DataStr += `"` + next.StaffID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.PersonTypeDesc + `",`;
			DataStr += `"` + next.SchoolFullName + `",`;
			DataStr += `"` + next.UserLevelDesc + `",`;
			DataStr += `"` + next.ActiveDesc + `"`;

			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "UsersWithNoRoles";

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////

	onUserRowSelect(val) {
		this.errorMessage = "";
	}

	onUserRowUnselect(val) {
		this.errorMessage = "";
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingUser == true || this.Processing == true;
	}
	////////////////////////////////////////////////
}
